module.exports = {
  footerText: 'Copyright Óptica Opticallery © 2021',
}
